import { getCourses } from '../data/course-data';
import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import './home.css';

const Home = () => {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []); 
    let Acourses = getCourses();
    let num = 4;
    let courses = Acourses.slice(0, num);
    return(
        //banner
    <div>
        <section className="banner-style-4 banner-padding">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-12 col-xl-8 col-lg-8">
                        <div className="banner-content">
                            <span className="subheading">Welcome to Abia Tech Hub Academy</span>
                            <h1 className="display-4 fw-bold mb-3">Transform Your Future with Tech Skills</h1>
                            <p className="lead mb-4">Join over 1,000+ successful graduates who have launched their tech careers through our industry-leading programs.</p>
                            <div className="stats-container mb-4">
                                <div className="row">
                                    <div className="col-4">
                                        <div className="stat-item">
                                            <h3 className="fw-bold">95%</h3>
                                            <p>Job Placement</p>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="stat-item">
                                            <h3 className="fw-bold">1000+</h3>
                                            <p>Graduates</p>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="stat-item">
                                            <h3 className="fw-bold">15+</h3>
                                            <p>Courses</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-container d-flex gap-3">
                                <Link to="/courses" className="btn rounded-pill px-4 py-2" style={{ 
                                    backgroundColor: '#8A038C', 
                                    color: 'white',
                                    border: '1px solid #8A038C',
                                    minWidth: '160px',
                                    textAlign: 'center'
                                }}>
                                    Explore Courses
                                </Link>
                                <Link to="/register" className="btn rounded-pill px-4 py-2" style={{ 
                                    backgroundColor: '#8A038C', 
                                    color: 'white',
                                    border: '1px solid #8A038C',
                                    minWidth: '160px',
                                    textAlign: 'center'
                                }}>
                                    Get Started
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="features-2 py-5 bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-xl-3 col-sm-6">
                        <div className="feature-item feature-style-top mb-4 mb-lg-0 hover-shadow">
                            <div className="feature-icon">
                                <i className="flaticon-teacher"></i>
                            </div>
                            <div className="feature-text">
                                <h4>Expert Teachers</h4>
                                <p>Learn from industry professionals with years of real-world experience</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-xl-3 col-sm-6">
                        <div className="feature-item feature-style-top mb-4 mb-lg-0 hover-shadow">
                            <div className="feature-icon">
                                <i className="flaticon-layer"></i>
                            </div>
                            <div className="feature-text">
                                <h4>Self Development</h4>
                                <p>Build a strong foundation with our comprehensive curriculum</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-xl-3 col-sm-6">
                        <div className="feature-item feature-style-top mb-4 mb-lg-0 hover-shadow">
                            <div className="feature-icon">
                                <i className="flaticon-education"></i>
                            </div>
                            <div className="feature-text">
                                <h4>Conducive Environment</h4>
                                <p>State-of-the-art facilities designed for optimal learning</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-xl-3 col-sm-6">
                        <div className="feature-item feature-style-top hover-shadow">
                            <div className="feature-icon">
                                <i className="flaticon-video-camera"></i>
                            </div>
                            <div className="feature-text">
                                <h4>Remote Learning</h4>
                                <p>Flexible learning options to fit your schedule</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

         {/* "Our Partners" section */}
      <section className="partners-section py-5">
        <div className="container">
          <div className="heading text-center mb-5">
            <span className="subheading">Our Strategic Partners</span>
            <h2 className="font-lg">Building the Future Together</h2>
            <p className="lead text-muted">We collaborate with industry leaders to provide you with the best learning experience</p>
          </div>

          <div className="row g-4">
            {/* IBM Partner */}
            <div className="col-lg-6">
              <div className="partner-card p-4 bg-white rounded-3 shadow-sm h-100">
                <div className="row align-items-center">
                  <div className="col-md-4 text-center">
                    <img src="assets/IBM1.png" alt="IBM" className="img-fluid partner-logo mb-3 mb-md-0" />
                  </div>
                  <div className="col-md-8">
                    <h4 className="mb-3">International Business Machines Corporation (IBM)</h4>
                    <p className="text-muted mb-3">We are proud to be partnered with IBM, a leading American computer manufacturer. Your certificate of completion proudly bears the IBM endorsement, significantly enhancing its value and credibility.</p>
                    <a href="https://ibm.com" className="btn rounded-pill" style={{ 
                        backgroundColor: '#8A038C', 
                        color: 'white',
                        border: '1px solid #8A038C'
                    }} target="_blank" rel="noreferrer">
                        Visit IBM <i className="fas fa-arrow-right ms-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* 3MTT Partner */}
            <div className="col-lg-6">
              <div className="partner-card p-4 bg-white rounded-3 shadow-sm h-100">
                <div className="row align-items-center">
                  <div className="col-md-4 text-center">
                    <img src="assets/3MTT.jpeg" alt="3MTT" className="img-fluid partner-logo mb-3 mb-md-0" />
                  </div>
                  <div className="col-md-8">
                    <h4 className="mb-3">3 Million Technical Talent (3MTT)</h4>
                    <p className="text-muted mb-3">Thrilled to announce our collaboration with the 3MTT programme. Together, we're building Nigeria's tech backbone and empowering our digital economy.</p>
                    <a href="https://3mtt.nitda.gov.ng/" className="btn rounded-pill" style={{ 
                        backgroundColor: '#8A038C', 
                        color: 'white',
                        border: '1px solid #8A038C'
                    }} target="_blank" rel="noreferrer">
                        Visit 3MTT <i className="fas fa-arrow-right ms-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Internet Society Partner */}
            <div className="col-lg-6">
              <div className="partner-card p-4 bg-white rounded-3 shadow-sm h-100">
                <div className="row align-items-center">
                  <div className="col-md-4 text-center">
                    <img src="assets/internetsociety.webp" alt="Internet Society" className="img-fluid partner-logo mb-3 mb-md-0" />
                  </div>
                  <div className="col-md-8">
                    <h4 className="mb-3">Internet Society Foundation</h4>
                    <p className="text-muted mb-3">We proudly partner with the Internet Society Foundation, supporting digital inclusion, innovation, and Internet access. Their sponsorship empowers us to enhance connectivity and create lasting impact.</p>
                    <a href="https://www.isocfoundation.org/" className="btn rounded-pill" style={{ 
                        backgroundColor: '#8A038C', 
                        color: 'white',
                        border: '1px solid #8A038C'
                    }} target="_blank" rel="noreferrer">
                        Visit ISOC <i className="fas fa-arrow-right ms-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* DeepTech Ready Partner */}
            <div className="col-lg-6">
              <div className="partner-card p-4 bg-white rounded-3 shadow-sm h-100">
                <div className="row align-items-center">
                  <div className="col-md-4 text-center">
                    <img src="assets/3mtt_long_logo.jpeg" alt="DeepTech Ready" className="img-fluid partner-logo mb-3 mb-md-0" />
                  </div>
                  <div className="col-md-8">
                    <h4 className="mb-3">DeepTech Ready</h4>
                    <p className="text-muted mb-3">Excited to partner with DeepTech Ready, a leading force in advancing deep technologies. Together, we're accelerating progress in AI, blockchain, IoT, and other deep tech domains.</p>
                    <a href="https://3mtt.nitda.gov.ng/deeptech/" className="btn rounded-pill" style={{ 
                        backgroundColor: '#8A038C', 
                        color: 'white',
                        border: '1px solid #8A038C'
                    }} target="_blank" rel="noreferrer">
                        Visit DeepTech <i className="fas fa-arrow-right ms-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        <section className="section-padding course-filter-section bg-light">
            <div className="container">
                <div className="row align-items-center justify-content-between mb-4">
                    <div className="col-xl-12">
                        <div className="heading text-center mb-5">
                            <span className="subheading">Featured Courses</span>
                            <h2 className="font-lg">Explore Our Popular Programs</h2>
                            <p className="lead text-muted">Discover courses designed to launch your tech career</p>
                        </div>
                    </div>
                </div>

                <div className="row course-gallery justify-content-center g-4">
                    {courses.map(course => (
                        <div className="col-lg-3 col-md-6 col-sm-6" key={course.id}>
                            <div className="course-card bg-white rounded-3 shadow-sm h-100">
                                <div className="course-header position-relative">
                                    <img src={course.img} alt={course.alt} className="img-fluid rounded-top" />
                                    <div className="course-level position-absolute top-0 end-0 m-3">
                                        <span className="badge" style={{ backgroundColor: '#8A038C' }}>Beginner</span>
                                    </div>
                                </div>

                                <div className="course-content p-4">
                                    <div className="course-meta d-flex justify-content-between align-items-center mb-3">
                                        <div className="rating">
                                            <i className="fas fa-star text-warning"></i>
                                            <span className="ms-1">{course.rating}</span>
                                        </div>
                                        <div className="students">
                                            <i className="fas fa-users" style={{ color: '#8A038C' }}></i>
                                            <span className="ms-1">{Math.floor(Math.random() * 25) + 5} students</span>
                                        </div>
                                    </div>
                                    <h3 className="h5 mb-3">
                                        <Link to={`/courses/${course.slug}`} className="text-decoration-none text-dark">
                                            {course.name}
                                        </Link>
                                    </h3>
                                    <p className="text-muted mb-3">{course.description}</p>
                                    <div className="course-footer d-flex justify-content-between align-items-center">
                                        <div className="price fw-bold">₦{course.price.toLocaleString()}</div>
                                        <Link to={`/courses/${course.slug}`} className="btn btn-primary">Learn More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="course-card bg-white rounded-3 shadow-sm h-100 d-flex align-items-center justify-content-center p-4">
                            <div className="text-center">
                                <h4 className="mb-3">Want to see more?</h4>
                                <p className="text-muted mb-4">Explore our complete course catalog</p>
                                <Link to="/courses" className="btn btn-primary rounded-pill">
                                    View All Courses <i className="fas fa-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <section className="work-process-section">
            <div className="container">
                <div className="row mb-70 justify-content-between">
                    <div className="col-xl-5">
                        <div className="section-heading text-center text-lg-start mb-4 mb-xl-0">
                            <h2 className="font-lg">4 steps start your journey with us</h2>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-6">
                        <div className="step-wrapper">
                            <div className="step-item ">
                                <div className="step-number bg-1">01</div>
                                <div className="step-text">
                                    <h5>Signup with all info</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3  col-lg-6 col-md-6">
                        <div className="step-wrapper">
                            <div className="step-item">
                                <div className="step-number bg-2">02</div>
                                <div className="step-text">
                                    <h5>Make payment</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3  col-lg-6 col-md-6">
                        <div className="step-wrapper">
                            <div className="step-item">
                                <div className="step-number bg-3">03</div>
                                <div className="step-text">
                                    <h5>Attend classes</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3  col-lg-6 col-md-6">
                        <div className="step-wrapper">
                            <div className="step-item">
                                <div className="step-number bg-2">04</div>
                                <div className="step-text">
                                    <h5>Get certified</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

        {/* Start Your Journey Section */}
        <section className="journey-section py-5">
            <div className="container">
                <div className="heading text-center mb-5">
                    <span className="subheading">Simple Enrollment Process</span>
                    <h2 className="font-lg">Start Your Journey With Us</h2>
                    <p className="lead text-muted">Four simple steps to begin your tech education journey</p>
                </div>

                <div className="row g-4 justify-content-center">
                    <div className="col-12">
                        <div className="row g-4 justify-content-center">
                            {/* Step 1 */}
                            <div className="col-lg-3 col-md-6">
                                <div className="journey-step text-center p-4 h-100">
                                    <div className="step-number mb-4">
                                        <span className="number-circle">01</span>
                                    </div>
                                    <div className="step-icon mb-4">
                                        <i className="fas fa-user-edit fa-2x"></i>
                                    </div>
                                    <h4 className="mb-3">Complete Registration</h4>
                                    <p className="text-muted mb-0">Sign up with your complete information to create your student profile</p>
                                </div>
                            </div>

                            {/* Step 2 */}
                            <div className="col-lg-3 col-md-6">
                                <div className="journey-step text-center p-4 h-100">
                                    <div className="step-number mb-4">
                                        <span className="number-circle">02</span>
                                    </div>
                                    <div className="step-icon mb-4">
                                        <i className="fas fa-credit-card fa-2x"></i>
                                    </div>
                                    <h4 className="mb-3">Make Payment</h4>
                                    <p className="text-muted mb-0">Secure payment process to enroll in your chosen course</p>
                                </div>
                            </div>

                            {/* Step 3 */}
                            <div className="col-lg-3 col-md-6">
                                <div className="journey-step text-center p-4 h-100">
                                    <div className="step-number mb-4">
                                        <span className="number-circle">03</span>
                                    </div>
                                    <div className="step-icon mb-4">
                                        <i className="fas fa-chalkboard-teacher fa-2x"></i>
                                    </div>
                                    <h4 className="mb-3">Start Learning</h4>
                                    <p className="text-muted mb-0">Begin attending classes and start your tech education journey</p>
                                </div>
                            </div>

                            {/* Step 4 */}
                            <div className="col-lg-3 col-md-6">
                                <div className="journey-step text-center p-4 h-100">
                                    <div className="step-number mb-4">
                                        <span className="number-circle">04</span>
                                    </div>
                                    <div className="step-icon mb-4">
                                        <i className="fas fa-certificate fa-2x"></i>
                                    </div>
                                    <h4 className="mb-3">Get Certified</h4>
                                    <p className="text-muted mb-0">Complete your course and receive your industry-recognized certificate</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-5">
                    <Link to="/register" className="btn rounded-pill px-4 py-2" style={{ 
                        backgroundColor: '#8A038C', 
                        color: 'white',
                        border: '1px solid #8A038C',
                        minWidth: '200px'
                    }}>
                        Register Now <i className="fas fa-arrow-right ms-2"></i>
                    </Link>
                </div>
            </div>
        </section>
    </div>

    );
}

export default Home;